import { ErrorPage } from "@backstage/core-components";
import {
  configApiRef,
  discoveryApiRef,
  useApi,
} from "@backstage/core-plugin-api";
import { useEffect } from "react";

import { isAppProxyActive, requestAppProxyProbe } from "./sessionGuard";

/**
 * Página 404 consciente de Azure AD / Entra Application Proxy.
 *
 * Renderiza SIEMPRE la página de 404 estándar (ErrorPage 404 / PAGE NOT FOUND);
 * el 404 legítimo, un DENY de RBAC o un backend sano nunca muestran
 * "sesión caducada".
 *
 * Únicamente si app.oauth2ProxyEnabled === true y window.location.origin
 * coincide con app.baseUrl, lanza el probe compartido (requestAppProxyProbe:
 * GET /api/auth/oauth2Proxy/refresh vía discovery, single-flight y retry
 * centralizados con useAppProxySessionGuard). Solo un resultado final
 * "expired" (401/403 o redirect demostrable a login) notifica la expiración
 * global; "unavailable" (5xx, 429, red, HTML 200, redirects no demostrables)
 * nunca lo hace.
 */
export const AppProxyAwareNotFoundPage = () => {
  const configApi = useApi(configApiRef);
  const discoveryApi = useApi(discoveryApiRef);

  const appProxyActive = isAppProxyActive(
    configApi,
    typeof window !== "undefined" ? window.location.origin : "",
  );

  useEffect(() => {
    if (!appProxyActive) {
      return undefined;
    }
    void requestAppProxyProbe(discoveryApi);
    return undefined;
  }, [appProxyActive, discoveryApi]);

  return <ErrorPage status="404" statusMessage="PAGE NOT FOUND" />;
};
